import { Link } from 'react-router-dom'
import { AdmBtn } from './AdminAtoms'

interface SubscriptionRequiredNoticeProps {
  /** Church slug — used to build the billing link. */
  slug: string
  /** Bold heading line of the notice. */
  title: string
  /** Explanatory body copy. */
  message: string
  /** CTA button label. Defaults to "View plans". */
  cta?: string
  /** Extra classes for the outer container (e.g. spacing). */
  className?: string
}

/**
 * Warm ochre upsell banner shown when a church action is blocked because the
 * church has no active subscription. Reused across the admin surfaces that gate
 * event creation (church events page, new-event form).
 */
export function SubscriptionRequiredNotice({
  slug,
  title,
  message,
  cta = 'View plans',
  className = '',
}: SubscriptionRequiredNoticeProps) {
  return (
    <div className={`px-5 py-[18px] rounded-[14px] bg-ochre-soft border border-ochre-line ${className}`}>
      <div className="flex items-start justify-between gap-4">
        <div className="min-w-0">
          <div className="text-[13.5px] font-semibold text-ochre">{title}</div>
          <div className="text-[12px] mt-0.5 leading-[1.5] text-ochre-muted">{message}</div>
        </div>
        <Link to={`/churches/${slug}/billing`} className="no-underline shrink-0">
          <AdmBtn variant="ochre" size="sm">{cta}</AdmBtn>
        </Link>
      </div>
    </div>
  )
}
